import React from 'react';
import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';
import { toast } from 'react-toastify';
import { EMPLOYEE_SHORTCUTS, USER_ROLES } from 'shared/consts';
import { NewUser } from 'shared/components';
import { matchUrlToRole } from 'shared/utils';
import getUsers from './getUsers';
import getActiveUser from './getActiveUser';
import getUsersAmount from './getUsersAmount';
import { showPreloader, hidePreloader } from '../viewManagement';

const init = () => ({
  type: USER.EDIT_USER_INIT,
});

export const success = data => ({
  type: USER.EDIT_USER_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: USER.EDIT_USER_FAILURE,
});

const editUser = userData => async dispatch => {
  dispatch(init());
  try {
    dispatch(showPreloader());
    delete userData.email;
    await Connector.editUser(userData);
    dispatch(getUsersAmount());

    await dispatch(getUsers(matchUrlToRole(window.location.pathname)));
    await toast(
      <NewUser
        badgeType={EMPLOYEE_SHORTCUTS[Object.keys(USER_ROLES).find(role => USER_ROLES[role] === userData.role)]}
        first_name={userData.first_name}
        label="Edytowano użytkownika"
        last_name={userData.last_name}
        phone={userData.phone}
      />,
    );
    dispatch(success(userData));
    if (userData.role === USER_ROLES.ADVISER) {
      await dispatch(getActiveUser(userData.uuid));
    }
    dispatch(hidePreloader());
  } catch (err) {
    dispatch(failure());
    dispatch(hidePreloader());
  }
};

export default editUser;
